<div class="common-text-input__container">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--error': field.error }"
    [attr.disabled]="field.noEditable ? true : null">
    <div class="common-text-input__block-header">
      <label class="common-text-input__label-no-cursor">
        <span class="common-text-input__text-label">
          {{fieldTypeOnefile.titleField}}
        </span>
        @if (!field.noEditable) {
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if(field.description) {
            <tooltip-info
              [description]="field.description"
              [field]="field">
            </tooltip-info>
          }
          @if (!field.noEditable && field.references && field.references?.length) {
            <tooltip-law
              [references]="field.references"
              [field]="field">
            </tooltip-law>
          }
        </div>
      </label>
      <div class="common-text-input__buttons-right-header">
        @if (field.evaluatedValue && field.evaluatedValue.hasReferences) {
          <button class="common-button__icon-sm-noborder"
            pTooltip="{{'common.see-dependencies' | afTranslate }}"
            tooltipPosition="left">
            <i class="lf-icon-connected-data common-icon__md"></i>
          </button>
        }
        <button class="common-button__icon-sm-noborder"
          (click)="fileInput.click()"
          [disabled]="field.noEditable">
          <i class="lf-icon-up-file common-icon__md"></i>
        </button>
      </div>
    </div>
    <div class="common-text-file__block-list-values">
        @if (fileInfo.name) {
          <div class="common-text-input__block-input"
            [ngClass]="{'common-text-input__block-input--with-value': !field.noEditable }">
            <div class="common-text-input__input">
              <button class="common-button__link"
                [disabled]="field.noEditable && !fieldTypeOnefile.lockedSavedConcept">
                <span class="common-button__link-text">
                  {{fileInfo.name}}
                </span>
              </button>
            </div>
            @if (!field.noEditable) {
              <button class="common-text-input__icon-clean-input"
                (click)="removeFile()">
                <i class="lf-icon-close-thick common-icon__sm">
                </i>
              </button>
            }
          </div>
        }
    </div>
    <input
      #fileInput
      [id]="fieldTypeOnefile.fieldId"
      class="common__hide"
      type="file"
      [accept]="field.accept"
      (change)="fileChanged($event)"
      [disabled]="field.noEditable"
    />
  </div>
  @if (field.error) {
    <div class="common-text-input__mandatory-tag">
      @if (field.blocker) {
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      @if (field.errorText) {
        <span>{{field.errorText}}</span>
      }@else {
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      }
    </div>
  }
</div>
